import React from "react";
import {PageHeading} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {Route} from "@/routing/Router";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";

type Props = {
    route: Route,
};

const OptionGroupsOverviewHeading = ({route}: Props) => {
    const intl = useIntl();

    return (
        <div className={"flex flex-col gap-4"}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={intl.formatMessage({id: "optionGroups"})}
                meta={<LocationPageMeta/>}
            />

            <p className={"w-full text-sm max-w-[600px] text-gray-500 dark:text-slate-400"}>
                <FormattedMessage id={"optionGroups.description"}/>
            </p>
        </div>
    );
};

export default OptionGroupsOverviewHeading;